export const JOURNEY_STATUS = {
  started: 'STARTED',
  declined: 'DECLINED',
};

export const UI_FW_MODES = {
  enterprise: 'Enterprise',
  express: 'Express',
  backoffice: 'Backoffice',
  userPortal: 'UserPortal',
};

export const WIZARD_DIRECTION = {
  forward: 'FORWARD',
  backward: 'BACKWARD',
};

export const CASE_STATUSES = {
  expired: 'EXPIRED',
  open: 'OPEN',
};

export const URL_PARAMS = ['inviteToken', 'flow', 'startJourney', 'caseId', 'username'];

export const FLOW_TYPE = {
  onboarding: 'ONBOARDING',
  loan: 'LOAN',
  contributor: 'CONTRIBUTOR',
};

export const OPEN_BANKING_IFRAME_EVENTS = {
  submittedConsentsDetails: 'Submitted_Consents_Details',
  signupComplete: 'Signup_Complete',
  singupSuccess: 'success',
};

export const SYSTEM_EVENTS = {
  START_RECORDING: 'START_RECORDING',
  STOP_RECORDING: 'STOP_RECORDING',
  FILE_UPLOADED: 'FILE_UPLOADED',
  CLIENT_TERMINATED: 'CLIENT_TERMINATED',
  SERVER_ERROR: 'SERVER_ERROR',
  PAGE_DID_MOUNT: 'Page_didMount',
  STEP_DID_MOUNT: 'Step_didMount',
  OPEN_URL: 'OPEN_URL',
  POPUP_OPEN: 'POPUP_OPEN',
};

const constants = {
  JOURNEY_STATUS,
  UI_FW_MODES,
  WIZARD_DIRECTION,
  CASE_STATUSES,
  OPEN_BANKING_IFRAME_EVENTS,
  SYSTEM_EVENTS,
};

export default constants;
